import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext'; // Import Provider
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Clients from './components/Clients';
import About from './components/About';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AIReadiness from './components/AIReadiness';
import './index.css';

// Helper component to handle scroll restoration and animation triggers on route change
const ScrollHandler = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        
        const checkAnimations = () => {
            const fadeElements = document.querySelectorAll('.fade-in');
            fadeElements.forEach(element => {
                const elementTop = element.getBoundingClientRect().top;
                const elementVisible = 150;
                if (elementTop < window.innerHeight - elementVisible) {
                    element.classList.add('visible');
                }
            });
        };

        // Run check immediately and after a short delay to ensure DOM is ready
        checkAnimations();
        setTimeout(checkAnimations, 100);
    }, [location]);

    return null;
};

function App() {
    const [showBackToTop, setShowBackToTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowBackToTop(window.scrollY > 500);
            const fadeElements = document.querySelectorAll('.fade-in');
            fadeElements.forEach(element => {
                const elementTop = element.getBoundingClientRect().top;
                const elementVisible = 150;
                if (elementTop < window.innerHeight - elementVisible) {
                    element.classList.add('visible');
                }
            });
        };
        
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial check
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <ToastProvider>
            <Router>
                <ScrollHandler />
                <div className="App">
                    <Navbar />
                    
                    <div className="content-container">
                        <Routes>
                            <Route path="/" element={
                                <>
                                    <Hero />
                                    <Clients />
                                    <Services />
                                    <CaseStudies />
                                    <section className="home-cta">
                                        <div className="container home-cta__inner fade-in">
                                            <p className="eyebrow">Start With Clarity</p>
                                            <h2>Get an executive-ready AI roadmap before you commit to a build.</h2>
                                            <p>We map opportunities, data constraints, governance risks, and the fastest route to measurable business value.</p>
                                            <div className="home-cta__actions">
                                                <Link className="btn-primary" to="/readiness">Check Readiness</Link>
                                                <Link className="btn-secondary" to="/contact">Book a Strategy Call</Link>
                                            </div>
                                        </div>
                                    </section>
                                </>
                            } />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/case-studies" element={<CaseStudies />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/readiness" element={<AIReadiness />} />
                        </Routes>
                    </div>

                    <Footer />
                    
                    <button className={`back-to-top ${showBackToTop ? 'visible' : ''}`} onClick={scrollToTop} aria-label="Back to top">
                        <i className="fas fa-arrow-up" aria-hidden="true"></i>
                    </button>
                </div>
            </Router>
        </ToastProvider>
    );
}

export default App;
